import { memo } from 'react';

import { FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type CopyToWorkspaceFailedPanelItemProps = {
  onClear: () => void;
};

export const CopyToWorkspaceFailedPanelItem = memo(({ onClear }: CopyToWorkspaceFailedPanelItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={<FileStatusTitle>{ui2026 ? 'Couldn’t copy' : 'Failed to save!'}</FileStatusTitle>}
      buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
    />
  );
});

CopyToWorkspaceFailedPanelItem.displayName = 'CopyToWorkspaceFailedPanelItem';
